
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[...param]",
      function () {
        return require("private-next-pages/page/[...param].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[...param]"])
      });
    }
  